import { USER_LOGOUT } from '../../../context/UserReducer';
import UserContext from '../../../context/UserContext';
import React, { useCallback, useState, useContext } from 'react';
import { TopBar, Button, HorizontalStack, Popover, ActionList } from '@shopify/polaris';
import { PopoverNotifications } from './PopoverNotifications';
import { useCurrency } from '../../../customHooks/useCurrency';
import { useTimezone } from '../../../customHooks/useTimezone';
import { SUPPORTED_TIMEZONES } from '../../../providers/timezone.provider';

export const MainTopBar = ({ toggleMobileNavigationActive }) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [, dispatch] = useContext(UserContext);
  const { name } = JSON.parse(localStorage.getItem('user')).user;
  const toggleIsUserMenuOpen = useCallback(() => setIsUserMenuOpen((isUserMenuOpen) => !isUserMenuOpen), []);

  const userMenuMarkup = (
    <TopBar.UserMenu
      actions={[
        {
          items: [
            {
              content: 'VER PERFIL',
              url: '/profile',
            },
            {
              content: 'CERRAR SESIÓN',
              onAction: () => dispatch({ type: USER_LOGOUT }),
            },
          ],
        },
      ]}
      name={name}
      open={isUserMenuOpen}
      onToggle={toggleIsUserMenuOpen}
    />
  );

  return (
    <TopBar
      showNavigationToggle
      onNavigationToggle={toggleMobileNavigationActive}
      secondaryMenu={<SecondaryMenu />}
      userMenu={userMenuMarkup}
    />
  );
};

const SecondaryMenu = () => {
  return (
    <HorizontalStack gap="2" blockAlign="center" wrap={false}>
      <TimezoneSelector />
      <CurrencySelector />
      <PopoverNotifications />
    </HorizontalStack>
  );
};

const TIMEZONE_LABELS = {
  'America/Mexico_City': 'CDMX',
  'Europe/Madrid': 'Madrid',
};

const TimezoneSelector = () => {
  const [popoverActive, setPopoverActive] = useState(false);
  const { timezone, changeTimezone } = useTimezone();
  const togglePopoverActive = useCallback(() => setPopoverActive((active) => !active), []);

  const handleChangeTimezone = (tz) => {
    changeTimezone(tz);
    togglePopoverActive();
  };

  const activator = (
    <Button onClick={togglePopoverActive} disclosure>
      {TIMEZONE_LABELS[timezone] || timezone}
    </Button>
  );

  return (
    <Popover active={popoverActive} activator={activator} autofocusTarget="first-node" onClose={togglePopoverActive}>
      <ActionList
        actionRole="menuitem"
        items={SUPPORTED_TIMEZONES.map((tz) => ({
          content: TIMEZONE_LABELS[tz] || tz,
          onAction: () => handleChangeTimezone(tz),
        }))}
      />
    </Popover>
  );
};

const CurrencySelector = () => {
  const [popoverActive, setPopoverActive] = useState(false);
  const { currency, changeCurrency } = useCurrency();
  const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);

  const handleChangeCurrency = (symbol) => {
    changeCurrency(symbol);
    togglePopoverActive();
  };

  const activator = (
    <Button onClick={togglePopoverActive} disclosure>
      {currency.symbol}
    </Button>
  );

  return (
    <Popover active={popoverActive} activator={activator} autofocusTarget="first-node" onClose={togglePopoverActive}>
      <ActionList
        actionRole="menuitem"
        items={[
          { content: 'MXN', onAction: () => handleChangeCurrency('MXN') },
          { content: 'EUR', onAction: () => handleChangeCurrency('EUR') },
        ]}
      />
    </Popover>
  );
};
